var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header',{attrs:{"title-ch":_vm.titleCh,"title-en":''}},[_c('div',{staticClass:"light first mobile_hide"}),_vm._v(" "),_c('div',{staticClass:"light second"}),_vm._v(" "),_c('div',{staticClass:"light third"}),_vm._v(" "),_c('div',{staticClass:"light fourth mobile_hide"})])
}
var staticRenderFns = []

export { render, staticRenderFns }